module.exports = __webpack_public_path__ + "static/media/Note.e1cb8d1d.svg";